

// import { useRef } from "react";
// import { Box, Container, Typography } from "@mui/material";
// import { motion, useReducedMotion } from "framer-motion";

// /* ───────────────── Fonts ───────────────── */
// const FontImport = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,750&family=DM+Sans:wght@300;400;500&display=swap');

//     .tb-grain {
//       position:absolute;
//       inset:0;
//       opacity:.025;
//       pointer-events:none;
//       background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
//     }
//   `}</style>
// );

// /* ───────────────── Icons ───────────────── */
// const icons = {
//   PhonePe: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M9 1.5L15.5 5.25V12.75L9 16.5L2.5 12.75V5.25L9 1.5Z"
//         stroke="currentColor"
//         strokeWidth="1.4"
//       />
//     </svg>
//   ),

//   Razorpay: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M11 2L4.5 9.5H9L7 16L13.5 8.5H9L11 2Z"
//         stroke="currentColor"
//         strokeWidth="1.4"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ),

//   Swiggy: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <circle
//         cx="9"
//         cy="9"
//         r="6.5"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//       <path
//         d="M5.5 9Q7.25 5.5 9 9Q10.75 12.5 12.5 9"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//     </svg>
//   ),

//   Zomato: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M4 3.5H14L4.5 14.5H14"
//         stroke="currentColor"
//         strokeWidth="1.5"
//       />
//     </svg>
//   ),

//   CRED: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M9 2L15 5V10.5C15 13.5 12.5 15.8 9 17C5.5 15.8 3 13.5 3 10.5V5L9 2Z"
//         stroke="currentColor"
//         strokeWidth="1.4"
//       />
//     </svg>
//   ),

//   Stripe: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M3 6.5C5.5 3.5 12.5 3.5 15 6.5"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//       <path
//         d="M3 9C5.5 12 12.5 12 15 9"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//     </svg>
//   ),

//   Spotify: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <circle
//         cx="9"
//         cy="9"
//         r="6.5"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//       <path
//         d="M6 7.5C7.5 7 10.5 7 12 7.5"
//         stroke="currentColor"
//         strokeWidth="1.1"
//       />
//       <path
//         d="M6.5 9.5C7.8 9.1 10.2 9.1 11.5 9.5"
//         stroke="currentColor"
//         strokeWidth="1.1"
//       />
//     </svg>
//   ),

//   Meta: () => (
//     <svg viewBox="0 0 18 18" fill="none">
//       <path
//         d="M2.5 9C2.5 6.5 4 4.5 5.5 4.5C7 4.5 7.8 6 9 6C10.2 6 11 4.5 12.5 4.5C14 4.5 15.5 6.5 15.5 9C15.5 11.5 14 13.5 12.5 13.5C11 13.5 10.2 12 9 12C7.8 12 7 13.5 5.5 13.5C4 13.5 2.5 11.5 2.5 9Z"
//         stroke="currentColor"
//         strokeWidth="1.3"
//       />
//     </svg>
//   ),
// };

// /* ───────────────── Data ───────────────── */
// const LOGOS = [
//   {
//     name: "OpenAI",
//     image: "/logos/openai.png",
//   },

//   {
//     name: "Claude",
//     image: "/logos/claude.png",
//   },

//   {
//     name: "Gemini",
//     image: "/logos/gemini.png",
//   },

//   // {
//   //   name: "Llama",
//   //   image: "/logos/llama.png",
//   // },

//   {
//     name: "AWS",
//     image: "/logos/aws.png",
//   },

//   {
//     name: "Google Cloud",
//     image: "/logos/gcp.png",
//   },

//   {
//     name: "Agora",
//     image: "/logos/agora.png",
//   },

//   {
//     name: "Razorpay",
//     image: "/logos/razorpay.png",
//   },

//   {
//     name: "PhonePe",
//     image: "/logos/phonepe.png",
//   },

//   // {
//   //   name: "Gamma",
//   //   image: "/logos/gamma.png",
//   // },
// ];

// const ROW_A = [...LOGOS, ...LOGOS];
// const ROW_B = [...LOGOS.reverse(), ...LOGOS.reverse()];

// /* ───────────────── Card ───────────────── */
// const LogoCard = ({ name, image }) => (
//   <Box
//     component={motion.div}
//     whileHover={{
//       y: -3,
//       scale: 1.04,
//     }}
//     transition={{
//       duration: 0.2,
//     }}
//     sx={{
//       position: "relative",
//       display: "flex",
//       alignItems: "center",
//       gap: "clamp(8px,1.5vw,14px)",

//       px: {
//         xs: 1.6,
//         sm: 2.2,
//         md: 2.8,
//       },

//       py: {
//         xs: 1,
//         sm: 1.2,
//         md: 1.5,
//       },

//       borderRadius: {
//         xs: "14px",
//         md: "16px",
//       },

//       overflow: "hidden",
//       flexShrink: 0,

//       background:
//         "linear-gradient(180deg, rgba(12,22,45,.92), rgba(5,10,22,.96))",

//       border:
//         "1px solid rgba(30,144,255,.16)",

//       backdropFilter: "blur(14px)",

//       boxShadow:
//         "inset 0 1px 0 rgba(255,255,255,.03)",

//       transition: "all .25s ease",

//       "&:hover": {
//         borderColor:
//           "rgba(30,144,255,.45)",

//         background:
//           "linear-gradient(180deg, rgba(20,40,80,.95), rgba(7,15,32,.98))",

//         boxShadow:
//           "0 12px 45px rgba(30,144,255,.18), inset 0 1px 0 rgba(255,255,255,.08)",
//       },
//     }}
//   >
//     {/* glow */}
//     <Box
//       sx={{
//         position: "absolute",
//         width: {
//           xs: 80,
//           md: 120,
//         },

//         height: {
//           xs: 80,
//           md: 120,
//         },

//         borderRadius: "50%",
//         top: -60,
//         right: -60,

//         background:
//           "radial-gradient(circle, rgba(30,144,255,.18), transparent 70%)",
//       }}
//     />

//     {/* icon */}
//     {/* logo image */}
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",

//         height: {
//           xs: 18,
//           md: 24,
//         },

//         flexShrink: 0,
//       }}
//     >
//       <Box
//         component="img"
//         src={image}
//         alt={name}
//         sx={{
//           maxWidth: {
//             xs: 22,
//             md: 28,
//           },

//           maxHeight: {
//             xs: 22,
//             md: 28,
//           },

//           width: "auto",
//           height: "auto",

//           objectFit: "contain",

//           filter:
//             "brightness(1.1)",

//           /* for dark logos */
//           background:
//             name === "OpenAI" ||
//               name === "AWS"
//               ? "#ffffff"
//               : "transparent",

//           borderRadius:
//             name === "OpenAI" ||
//               name === "AWS"
//               ? "6px"
//               : 0,

//           padding:
//             name === "OpenAI" ||
//               name === "AWS"
//               ? "2px"
//               : 0,
//         }}
//       />
//     </Box>

//     {/* text */}
//     <Typography
//       sx={{
//         fontFamily: "'DM Sans', sans-serif",
//         fontWeight: 600,

//         fontSize: {
//           xs: ".72rem",
//           sm: ".82rem",
//           md: ".95rem",
//         },

//         color: "rgba(255,255,255,.92)",

//         letterSpacing: ".02em",
//         whiteSpace: "nowrap",
//       }}
//     >
//       {name}
//     </Typography>
//   </Box>
// );

// /* ───────────────── Marquee ───────────────── */
// const MarqueeRow = ({
//   logos,
//   direction = "left",
//   duration = 32,
// }) => {
//   const reduced = useReducedMotion();

//   const animateX =
//     direction === "left"
//       ? { x: ["0%", "-50%"] }
//       : { x: ["-50%", "0%"] };

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* left fade */}
//       <Box
//         sx={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           bottom: 0,

//           width: {
//             xs: 25,
//             sm: 60,
//             md: 180,
//           },

//           background:
//             "linear-gradient(to right, #000000 0%, transparent 100%)",

//           zIndex: 2,
//         }}
//       />

//       {/* right fade */}
//       <Box
//         sx={{
//           position: "absolute",
//           right: 0,
//           top: 0,
//           bottom: 0,

//           width: {
//             xs: 25,
//             sm: 60,
//             md: 180,
//           },

//           background:
//             "linear-gradient(to left, #000000 0%, transparent 100%)",

//           zIndex: 2,
//         }}
//       />

//       <motion.div
//         animate={reduced ? {} : animateX}
//         transition={{
//           duration,
//           repeat: Infinity,
//           ease: "linear",
//         }}
//         style={{
//           display: "flex",
//           gap: "clamp(10px,2vw,14px)",
//           width: "max-content",
//         }}
//       >
//         {logos.map((logo, i) => (
//           <LogoCard
//             key={`${logo.name}-${i}`}
//             {...logo}
//           />
//         ))}
//       </motion.div>
//     </Box>
//   );
// };

// /* ───────────────── Animations ───────────────── */
// const fadeUp = (delay = 0) => ({
//   initial: {
//     opacity: 0,
//     y: 20,
//   },

//   whileInView: {
//     opacity: 1,
//     y: 0,
//   },

//   viewport: {
//     once: true,
//   },

//   transition: {
//     duration: 0.65,
//     delay,
//     ease: [0.22, 1, 0.36, 1],
//   },
// });

// /* ───────────────── Main Component ───────────────── */
// export default function TrustedBy() {
//   return (
//     <>
//       <FontImport />

//       <Box
//         component="section"
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//           background: "#000000",

//           pt: {
//             xs: 10,
//             sm: 12,
//             md: 16,
//             lg: 18,
//           },

//           pb: {
//             xs: 10,
//             sm: 12,
//             md: 16,
//             lg: 18,
//           },
//         }}
//       >
//         {/* grain */}
//         <Box className="tb-grain" />

//         {/* top orb */}
//         <Box
//           component={motion.div}
//           animate={{
//             scale: [1, 1.12, 1],
//             opacity: [0.5, 0.9, 0.5],
//           }}
//           transition={{
//             duration: 8,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//           sx={{
//             position: "absolute",
//             top: "-10%",
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: 220,
//               sm: 320,
//               md: 600,
//               lg: 760,
//             },

//             height: {
//               xs: 180,
//               sm: 240,
//               md: 420,
//               lg: 520,
//             },

//             borderRadius: "50%",

//             background:
//               "radial-gradient(ellipse, rgba(30,144,255,.16) 0%, transparent 70%)",

//             filter: "blur(60px)",
//           }}
//         />

//         {/* separator */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.22), transparent)",
//           }}
//         />

//         {/* content */}
//         <Container
//           maxWidth="xl"
//           sx={{
//             position: "relative",
//             zIndex: 2,
//             textAlign: "center",

//             mb: {
//               xs: 6,
//               md: 10,
//             },

//             px: {
//               xs: 2,
//               sm: 3,
//               md: 4,
//             },
//           }}
//         >
//           {/* label */}
//           <motion.div {...fadeUp(0)}>
//             <Box
//               sx={{
//                 display: "inline-flex",
//                 alignItems: "center",

//                 gap: {
//                   xs: 1,
//                   md: 1.2,
//                 },

//                 mb: {
//                   xs: 2.5,
//                   md: 3.5,
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   width: {
//                     xs: 12,
//                     md: 18,
//                   },

//                   height: "1px",

//                   background:
//                     "rgba(30,144,255,.6)",
//                 }}
//               />

//               <Typography
//                 sx={{
//                   fontFamily:
//                     "'DM Sans', sans-serif",

//                   fontSize: {
//                     xs: ".6rem",
//                     sm: ".7rem",
//                     md: ".72rem",
//                   },

//                   fontWeight: 700,

//                   color:
//                     "rgba(88,178,255,.9)",

//                   letterSpacing: ".15em",

//                   textTransform:
//                     "uppercase",
//                 }}
//               >
//                 Built With Modern AI Stack
//               </Typography>

//               <Box
//                 sx={{
//                   width: {
//                     xs: 12,
//                     md: 18,
//                   },

//                   height: "1px",

//                   background:
//                     "rgba(30,144,255,.6)",
//                 }}
//               />
//             </Box>
//           </motion.div>

//           {/* heading */}
//           <motion.div {...fadeUp(.08)}>
//             <Typography
//               component="h2"
//               sx={{
//                 fontFamily: "'Bricolage Grotesque', sans-serif",
//                 fontWeight: 750,
//                 fontSize: { xs: "1.9rem", sm: "2.4rem", md: "3rem" },
//                 lineHeight: 1.1,
//                 letterSpacing: { xs: "-1px", md: "-1.8px" },
//                 color: "rgba(255,255,255,.93)",
//                 mb: 2.5,
//               }}
//             >
//               Powered by

//               <br />

//               <Box
//                 component="span"
//                 sx={{
//                   background:
//                     "#1E90FF",

//                   WebkitBackgroundClip:
//                     "text",

//                   WebkitTextFillColor:
//                     "transparent",
//                 }}
//               >
//                 latest AI infrastructure
//               </Box>
//             </Typography>
//           </motion.div>

//           {/* subtitle */}
//           <motion.div {...fadeUp(.16)}>
//             <Typography
//               sx={{
//                 maxWidth: {
//                   xs: "95%",
//                   sm: "88%",
//                   md: "620px",
//                 },

//                 mx: "auto",

//                 fontFamily:
//                   "'DM Sans', sans-serif",

//                 fontSize: {
//                   xs: ".9rem",
//                   sm: ".95rem",
//                   md: "1rem",
//                   lg: "1.05rem",
//                 },

//                 lineHeight: {
//                   xs: 1.8,
//                   md: 1.9,
//                 },

//                 color:
//                   "rgba(210,230,255,.72)",
//               }}
//             >
//               Leveraging state-of-the-art AI models,
//               cloud infrastructure, realtime communication,
//               and enterprise-grade technology stacks to
//               build scalable intelligent systems.
//             </Typography>
//           </motion.div>
//         </Container>

//         {/* marquees */}
//         <Box
//           sx={{
//             position: "relative",
//             zIndex: 2,

//             display: "flex",
//             flexDirection: "column",

//             gap: {
//               xs: 1.5,
//               sm: 2,
//               md: 3,
//             },
//           }}
//         >
//           <MarqueeRow
//             logos={ROW_A}
//             direction="left"
//             duration={38}
//           />

//           <MarqueeRow
//             logos={ROW_B}
//             direction="right"
//             duration={32}
//           />
//         </Box>


//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.15), transparent)",
//           }}
//         />

//       </Box>
//     </>
//   );
// }


import { Box, Container, Typography } from "@mui/material";
import { motion, useReducedMotion } from "framer-motion";

/* ─────────────────────── GLOBAL STYLES ──────────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,750;12..96,800&family=DM+Sans:wght@300;400;500;600&display=swap');

    /* Ambient orb pulse — CSS only, cheaper than Framer for simple pulses */
    @keyframes tb-orb-pulse {
      0%, 100% { opacity: .38; transform: translateX(-50%) scale(1);    }
      50%       { opacity: .72; transform: translateX(-50%) scale(1.14); }
    }
    /* Subtle tile shimmer on hover (GPU-composite only) */
    @keyframes tb-shimmer {
      0%   { opacity: 0; transform: translateX(-100%) skewX(-18deg); }
      60%  { opacity: 1; }
      100% { opacity: 0; transform: translateX(100%)  skewX(-18deg); }
    }
    .tb-shimmer::after {
      content: '';
      position: absolute; inset: 0;
      background: linear-gradient(90deg, transparent 0%, rgba(30,144,255,.12) 50%, transparent 100%);
      transform: translateX(-100%) skewX(-18deg);
      transition: none;
    }
    .tb-tile:hover .tb-shimmer::after {
      animation: tb-shimmer .55s ease forwards;
    }
    /* Noise grain */
    .tb-grain {
      position: absolute; inset: 0; z-index: 0;
      pointer-events: none; opacity: .018;
      mix-blend-mode: overlay;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='260'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.78' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
    }
  `}</style>
);

/* ─────────────────────── LOGO CATALOGUE ─────────────────────────── */
/*
  filter:
    "white"   → brightness(0) invert(1)               pure-white silhouette
    "lighten" → brightness(.15) invert(1) opacity(.82) softer off-white
    "color"   → no filter; logo is already light/colourful on dark bg
    "dim"     → brightness(1.4) saturate(1.1)          lift slightly-dark colour logos
*/
/*
  mw / mh  — optional per-logo maxWidth / maxHeight overrides (responsive array or scalar).
             When omitted the LogoTile uses the default proportional sizes.

  Wide text/wordmark logos (AWS, Razorpay, Agora) need more maxWidth and less maxHeight
  so they don't get squashed.  Icon-only logos (OpenAI, Gemini, Claude) need more maxHeight
  relative to width so they don't disappear.
*/
const LOGOS = [
  {
    name: "OpenAI",
    src:  "/logos/openai.png",
    treat:"white",
    // Pure icon — allow it to be taller
    mh: { xs:"28px", sm:"32px", md:"38px", lg:"42px", xl:"46px" },
    mw: { xs:"28px", sm:"32px", md:"38px", lg:"42px", xl:"46px" },
  },
  {
    name: "Claude",
    src:  "/logos/claude.png",
    treat:"color",
    // Icon mark — give it room to breathe
    mh: { xs:"26px", sm:"30px", md:"36px", lg:"40px", xl:"44px" },
    mw: { xs:"52px", sm:"60px", md:"70px", lg:"78px", xl:"86px" },
  },
  {
    name: "Gemini",
    src:  "/logos/gemini.png",
    treat:"color",
    mh: { xs:"26px", sm:"30px", md:"36px", lg:"40px", xl:"44px" },
    mw: { xs:"52px", sm:"60px", md:"70px", lg:"78px", xl:"86px" },
  },
  {
    name: "AWS",
    src:  "/logos/aws-light.webp",
    treat:"color",
    // Wide wordmark — needs more width, less height constraint
    mw: { xs:"54px", sm:"62px", md:"74px", lg:"82px", xl:"90px" },
    mh: { xs:"28px", sm:"32px", md:"38px", lg:"42px", xl:"46px" },
    // Make the tile itself a little wider to give the wordmark breathing room
    tw: { xs:"88px", sm:"104px", md:"122px", lg:"136px", xl:"148px" },
  },
  {
    name: "Google Cloud",
    src:  "/logos/gcp-3.png",
    treat:"color",
    mh: { xs:"26px", sm:"30px", md:"36px", lg:"40px", xl:"44px" },
    mw: { xs:"52px", sm:"60px", md:"70px", lg:"78px", xl:"86px" },
  },
  {
    name: "Agora",
    src:  "/logos/agora.png",
    treat:"color",
    // Wide wordmark
    mw: { xs:"52px", sm:"60px", md:"70px", lg:"78px", xl:"86px" },
    mh: { xs:"22px", sm:"25px", md:"30px", lg:"33px", xl:"36px" },
    tw: { xs:"84px", sm:"98px",  md:"116px",lg:"130px",xl:"142px"},
  },
  {
    name: "Razorpay",
    src:  "/logos/razorpay.svg",
    treat:"color",
    // Wide wordmark
    mw: { xs:"56px", sm:"64px", md:"76px", lg:"84px", xl:"92px" },
    mh: { xs:"22px", sm:"25px", md:"30px", lg:"33px", xl:"36px" },
    tw: { xs:"88px", sm:"104px",md:"122px",lg:"136px",xl:"148px"},
  },
  {
    name: "PhonePe",
    src:  "/logos/phonepe.png",
    treat:"",
    // Has both an icon and wordmark — needs more height AND width
    mw: { xs:"56px", sm:"64px", md:"76px", lg:"84px", xl:"92px" },
    mh: { xs:"30px", sm:"34px", md:"40px", lg:"44px", xl:"48px" },
    tw: { xs:"88px", sm:"104px",md:"122px",lg:"136px",xl:"148px"},
    th: { xs:"52px", sm:"58px", md:"68px", lg:"76px", xl:"82px" },
  },
];

/* CSS filter string per treatment */
const FILTERS = {
  white:   "brightness(0) invert(1)",
  lighten: "brightness(0) invert(1) opacity(.78)",
  color:   "brightness(1.05) saturate(1.05)",
  dim:     "brightness(1.4) saturate(1.1)",
};
/* Hover-state filter (slightly brighter / more vivid) */
const FILTERS_HOVER = {
  white:   "brightness(0) invert(1) drop-shadow(0 0 8px rgba(30,144,255,.55))",
  lighten: "brightness(0) invert(1) opacity(.95) drop-shadow(0 0 6px rgba(30,144,255,.45))",
  color:   "brightness(1.15) saturate(1.2)  drop-shadow(0 0 7px rgba(30,144,255,.38))",
  dim:     "brightness(1.6)  saturate(1.25) drop-shadow(0 0 7px rgba(30,144,255,.38))",
};

/* 3× each row so the loop is gapless at any viewport width */
const ROW_A = [...LOGOS, ...LOGOS, ...LOGOS];
const ROW_B = [...[...LOGOS].reverse(), ...[...LOGOS].reverse(), ...[...LOGOS].reverse()];

/* ─────────────────────── DEFAULT LOGO SIZES ────────────────────── */
// Fallback dimensions — used when a logo entry omits mw / mh / tw / th
const DEFAULT_IMG_W = { xs: "44px", sm: "52px", md: "62px", lg: "68px", xl: "74px" };
const DEFAULT_IMG_H = { xs: "22px", sm: "25px", md: "30px", lg: "33px", xl: "36px" };
const DEFAULT_TILE_W = { xs: "68px",  sm: "80px",  md: "96px",  lg: "106px", xl: "116px" };
const DEFAULT_TILE_H = { xs: "46px",  sm: "52px",  md: "62px",  lg: "68px",  xl: "74px"  };

/* ─────────────────────── LOGO TILE ──────────────────────────────── */
// mw / mh  — logo image max-width / max-height (responsive object or scalar)
// tw / th  — tile width / height override for wide wordmarks
const LogoTile = ({ name, src, treat = "color", mw, mh, tw, th }) => (
  <Box
    className="tb-tile"
    component={motion.div}
    whileHover={{ y: -3, scale: 1.055 }}
    transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    aria-label={name}
    sx={{
      position: "relative",
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      cursor: "default",
      userSelect: "none",

      /* Use per-logo tile size when provided, else default */
      width:  tw ?? DEFAULT_TILE_W,
      height: th ?? DEFAULT_TILE_H,
      borderRadius: { xs: "12px", sm: "13px", md: "14px", lg: "15px" },

      background:
        "linear-gradient(145deg, rgba(255,255,255,.028) 0%, rgba(255,255,255,.012) 100%)",
      border: "1px solid rgba(255,255,255,.055)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      boxShadow: "inset 0 1px 0 rgba(255,255,255,.04)",
      transition: "border-color .28s ease, box-shadow .28s ease",

      "&:hover": {
        borderColor: "rgba(30,144,255,.32)",
        boxShadow:
          "0 0 0 1px rgba(30,144,255,.12)," +
          "0 12px 36px rgba(30,144,255,.14)," +
          "inset 0 1px 0 rgba(255,255,255,.07)",
      },
    }}
  >
    {/* Shimmer sweep */}
    <Box className="tb-shimmer" sx={{
      position: "absolute", inset: 0, zIndex: 2, pointerEvents: "none",
    }}/>

    {/* Logo image — uses per-logo dimensions or falls back to defaults */}
    <Box
      component="img"
      src={src}
      alt={name}
      loading="lazy"
      sx={{
        position: "relative",
        zIndex: 1,
        display: "block",
        maxWidth:  mw ?? DEFAULT_IMG_W,
        maxHeight: mh ?? DEFAULT_IMG_H,
        width: "auto",
        height: "auto",
        objectFit: "contain",
        filter: FILTERS[treat],
        transition: "filter .28s ease, transform .22s ease",
        ".tb-tile:hover &": {
          filter: FILTERS_HOVER[treat],
        },
      }}
    />
  </Box>
);

/* ─────────────────────── MARQUEE ROW ────────────────────────────── */
const MarqueeRow = ({ logos, direction = "left", duration = 40 }) => {
  const reduced = useReducedMotion();

  /* Animate 1/3 of the strip — matches 3× duplication above */
  const xFrom = direction === "left" ? "0%"         : "-33.3334%";
  const xTo   = direction === "left" ? "-33.3334%"  : "0%";

  return (
    <Box sx={{ position: "relative", overflow: "hidden" }}>

      {/* ── Left edge fade ── */}
      <Box aria-hidden sx={{
        position: "absolute", left: 0, top: 0, bottom: 0, zIndex: 3,
        width: { xs: "40px", sm: "80px", md: "160px", lg: "220px", xl: "300px" },
        background: "linear-gradient(to right, #000000 0%, transparent 100%)",
        pointerEvents: "none",
      }}/>

      {/* ── Right edge fade ── */}
      <Box aria-hidden sx={{
        position: "absolute", right: 0, top: 0, bottom: 0, zIndex: 3,
        width: { xs: "40px", sm: "80px", md: "160px", lg: "220px", xl: "300px" },
        background: "linear-gradient(to left, #000000 0%, transparent 100%)",
        pointerEvents: "none",
      }}/>

      <motion.div
        animate={reduced ? {} : { x: [xFrom, xTo] }}
        transition={{ duration, repeat: Infinity, ease: "linear" }}
        style={{
          display: "flex",
          /* Gap scales with viewport; larger gap on wide = more airiness */
          gap: "clamp(10px, 1.4vw, 16px)",
          width: "max-content",
          /* Vertical breathing room for hover lift */
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        {logos.map((logo, i) => (
          <LogoTile key={`${logo.name}-${i}`} {...logo} />
        ))}
      </motion.div>
    </Box>
  );
};

/* ─────────────────────── FADE-UP HELPER ─────────────────────────── */
const fadeUp = (delay = 0) => ({
  initial:     { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0  },
  viewport:    { once: true, margin: "-40px" },
  transition:  { duration: 0.68, delay, ease: [0.22, 1, 0.36, 1] },
});

/* ─────────────────────── MAIN EXPORT ───────────────────────────── */
export default function TrustedBy() {
  return (
    <>
      <Styles />

      <Box
        component="section"
        aria-label="AI Stack & Technology Partners"
        sx={{
          position: "relative",
          overflow: "hidden",
          background: "#000000",
          /* Consistent vertical rhythm with other sections */
          pt: { xs: "64px", sm: "80px", md: "100px", lg: "118px", xl: "136px" },
          pb: { xs: "72px", sm: "88px", md: "108px", lg: "126px", xl: "144px" },
        }}
      >
        {/* Grain */}
        <Box className="tb-grain" aria-hidden />

        {/* ── Main ambient orb (CSS-animated, GPU-only) ── */}
        <Box aria-hidden sx={{
          position: "absolute",
          top: "-16%", left: "50%",
          animation: "tb-orb-pulse 10s ease-in-out infinite",
          width:  { xs: "260px", sm: "400px", md: "660px", lg: "840px", xl: "1000px" },
          height: { xs: "180px", sm: "280px", md: "460px", lg: "580px", xl: "680px"  },
          borderRadius: "50%",
          background:
            "radial-gradient(ellipse, rgba(30,144,255,.12) 0%, rgba(30,144,255,.04) 45%, transparent 72%)",
          filter: "blur(70px)",
          pointerEvents: "none",
        }}/>

        {/* ── Left depth orb ── */}
        <Box aria-hidden sx={{
          position: "absolute", top: "18%", left: "-7%",
          width:  { xs: "180px", md: "300px", lg: "400px", xl: "480px" },
          height: { xs: "180px", md: "300px", lg: "400px", xl: "480px" },
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(30,144,255,.045) 0%, transparent 70%)",
          filter: "blur(80px)", pointerEvents: "none",
        }}/>

        {/* ── Right depth orb ── */}
        <Box aria-hidden sx={{
          position: "absolute", bottom: "8%", right: "-6%",
          width:  { xs: "160px", md: "260px", lg: "360px", xl: "440px" },
          height: { xs: "160px", md: "260px", lg: "360px", xl: "440px" },
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(30,144,255,.04) 0%, transparent 70%)",
          filter: "blur(70px)", pointerEvents: "none",
        }}/>

        {/* ── Top separator ── */}
        <Box aria-hidden sx={{
          position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
          width: { xs: "80%", md: "62%" }, height: "1px",
          background:
            "linear-gradient(to right, transparent, rgba(30,144,255,.2), transparent)",
          pointerEvents: "none",
        }}/>

        {/* ═══════════════════ HEADER ═══════════════════ */}
        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            px: { xs: "16px", sm: "24px", md: "40px", lg: "56px", xl: "72px" },
            maxWidth: { xl: "1440px" },
            mb: { xs: "44px", sm: "56px", md: "68px", lg: "76px" },
          }}
        >
          {/* Eyebrow */}
          <motion.div {...fadeUp(0)}>
            <Box sx={{
              display: "inline-flex", alignItems: "center",
              gap: { xs: "10px", md: "14px" },
              mb: { xs: "20px", md: "26px" },
            }}>
              <Box sx={{
                width: { xs: "14px", md: "20px" }, height: "1px",
                background: "rgba(30,144,255,.55)",
              }}/>
              <Typography sx={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "clamp(.6rem, .85vw, .73rem)",
                fontWeight: 700,
                color: "rgba(88,178,255,.88)",
                letterSpacing: ".14em",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
              }}>
                Built With Modern AI Stack
              </Typography>
              <Box sx={{
                width: { xs: "14px", md: "20px" }, height: "1px",
                background: "rgba(30,144,255,.55)",
              }}/>
            </Box>
          </motion.div>

          {/* Heading */}
          <motion.div {...fadeUp(0.08)}>
            <Typography
              component="h2"
              sx={{
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontWeight: 750,
                fontSize: "clamp(1.7rem, 4vw, 3.1rem)",
                lineHeight: 1.08,
                letterSpacing: "clamp(-1px, -0.05em, -1.8px)",
                color: "rgba(255,255,255,.93)",
                mb: { xs: "14px", md: "18px" },
                wordBreak: "break-word",
              }}
            >
              Powered by&nbsp;
              <Box component="span" sx={{
                background: "#1E90FF",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}>
                latest AI infrastructure
              </Box>
            </Typography>
          </motion.div>

          {/* Subtitle */}
          <motion.div {...fadeUp(0.16)}>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "clamp(.86rem, 1.15vw, 1rem)",
              lineHeight: 1.88,
              color: "rgba(210,230,255,.62)",
              maxWidth: { xs: "100%", sm: "500px", md: "580px" },
              mx: "auto",
            }}>
              Leveraging state-of-the-art AI models, cloud infrastructure,
              realtime communication, and enterprise-grade technology stacks
              to build scalable intelligent systems.
            </Typography>
          </motion.div>
        </Container>

        {/* ═══════════════════ MARQUEE ROWS ═══════════════════ */}
        <Box sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          gap: { xs: "11px", sm: "13px", md: "14px", lg: "16px" },
        }}>
          <MarqueeRow logos={ROW_A} direction="left"  duration={48} />
          <MarqueeRow logos={ROW_B} direction="right" duration={38} />
        </Box>

        {/* ── Bottom separator ── */}
        <Box aria-hidden sx={{
          position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)",
          width: { xs: "80%", md: "62%" }, height: "1px",
          background:
            "linear-gradient(to right, transparent, rgba(30,144,255,.14), transparent)",
          pointerEvents: "none",
        }}/>
      </Box>
    </>
  );
}